import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/save': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M433.9 129.9c7.8 7.8 14.1 23 14.1 33.9v268.1c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h268.1c11 0 26.2 6.3 33.9 14.1zM272 80h-128v80h128v-80zM394 432c3.3 0 6-2.7 6-6v-259.6 0c0-1.4-0.8-3.3-1.8-4.2l-78.2-78.2v100.1c0 13.3-10.7 24-24 24h-176c-13.3 0-24-10.7-24-24v-104h-42c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340zM224 232c48.5 0 88 39.5 88 88s-39.5 88-88 88-88-39.5-88-88 39.5-88 88-88zM224 360c22.1 0 40-17.9 40-40s-17.9-40-40-40-40 17.9-40 40 17.9 40 40 40z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/save.js
// module id = 1813
// module chunks = 0